// ============================================================
// ENVIRONNEMENT: Détection automatique (production ou développement)
// ============================================================

import axios from 'axios';
import { getApiUrl, isProduction } from '../utils/env.js';

// Obtenir l'URL de l'API selon l'environnement
const API_GET = getApiUrl();

// Log pour débogage
if (typeof window !== 'undefined') {
  console.log('🔧 Configuration axios:');
  console.log('  - Production détectée:', isProduction());
  console.log('  - API_GET:', API_GET);
  console.log('  - hostname:', window.location.hostname);
  if (isProduction()) {
    console.log('  ✅ Mode PRODUCTION - URL API: https://app-secura.com');
  } else {
    console.log('  🔧 Mode DÉVELOPPEMENT détecté');
  }
}

// Créer une instance axios configurée par défaut
const axiosInstance = axios.create({
  baseURL: API_GET,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000, // 30 secondes
});

// Intercepteur pour les requêtes
axiosInstance.interceptors.request.use(
  (config) => {
    // Ajouter le token d'authentification si disponible
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log('🔑 Token ajouté à la requête');
    } else {
      console.warn('⚠️ Aucun token trouvé dans localStorage pour la requête:', config.url);
    }
    
    // Log pour débogage (URL complète)
    if (typeof window !== 'undefined') {
      const fullUrl = config.baseURL 
        ? `${config.baseURL}${config.url}` 
        : `${window.location.origin}${config.url}`;
      console.log(`🔍 Requête axios: ${config.method?.toUpperCase()} ${fullUrl}`);
      console.log(`🔍 baseURL: "${config.baseURL || '(relative)'}", url: "${config.url}"`);
      console.log(`🔍 Origin: ${window.location.origin}`);
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour les réponses
axiosInstance.interceptors.response.use(
  (response) => {
    // Réinitialiser l'état d'erreur réseau si une requête réussit
    if (typeof window !== 'undefined' && window.dispatchEvent) {
      window.dispatchEvent(new CustomEvent('network-success'));
    }
    return response;
  },
  (error) => {
    // Log détaillé pour débogage
    if (error.response) {
      console.error(`❌ Erreur API: ${error.response.status} - ${JSON.stringify(error.response.data)}`);
      console.error(`❌ URL: ${error.config?.baseURL || ''}${error.config?.url}`);
    } else if (error.request) {
      console.error('❌ Pas de réponse du serveur:', error.request);
      console.error(`❌ URL tentée: ${error.config?.baseURL || ''}${error.config?.url}`);
      
      // Détecter les erreurs réseau et émettre un événement
      if (typeof window !== 'undefined' && window.dispatchEvent) {
        const isNetworkErr = !navigator.onLine || 
                           error.message?.includes('Network Error') ||
                           error.message?.includes('Failed to fetch') ||
                           error.code === 'ERR_NETWORK' ||
                           error.message?.includes('fetch');
        
        if (isNetworkErr) {
          window.dispatchEvent(new CustomEvent('network-error', { 
            detail: { error } 
          }));
        }
      }
    } else {
      console.error('❌ Erreur de configuration:', error.message);
    }
    
    // Gérer les erreurs 401 (non authentifié)
    if (error.response?.status === 401) {
      // Optionnel: rediriger vers la page de connexion
      // window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Exporter l'instance axios configurée
export default axiosInstance;

// Exporter aussi l'URL de l'API pour les cas où on a besoin de construire des URLs manuellement
export { API_GET };
